// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --mechanic-text: #333;
  --mechanic-background: transparent;
  --mechanic-dust-gray: #f3f1f2;
  --mechanic-gray: #aaa;
  --mechanic-disabled: #545454;
  --mechanic-black: #231f20;
  --mechanic-blue: #002ebb;
  --mechanic-light-blue: #f4f7fe;
  --mechanic-red: #e94225;
  --mechanic-light-red: #fdd7d1;
  --mechanic-green: #21c30f;
  --mechanic-input-font-size: 1em;
  --mechanic-label-font-size: 0.75em;
  --mechanic-input-font: "Object Sans", Helvetica, sans-serif;
  --mechanic-error: #f04b17;
  --mechanic-input-height: 2.5em;
  --mechanic-input-height-half: 1.25em;
  --mechanic-input-height-quart: 0.75em;
  --mechanic-input-height-eighth: 0.375em;
}
`, "",{"version":3,"sources":["webpack://./../ui-components/src/variables.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,kCAAkC;EAClC,2DAA2D;EAC3D,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,uCAAuC;AACzC","sourcesContent":[":root {\n  --mechanic-text: #333;\n  --mechanic-background: transparent;\n  --mechanic-dust-gray: #f3f1f2;\n  --mechanic-gray: #aaa;\n  --mechanic-disabled: #545454;\n  --mechanic-black: #231f20;\n  --mechanic-blue: #002ebb;\n  --mechanic-light-blue: #f4f7fe;\n  --mechanic-red: #e94225;\n  --mechanic-light-red: #fdd7d1;\n  --mechanic-green: #21c30f;\n  --mechanic-input-font-size: 1em;\n  --mechanic-label-font-size: 0.75em;\n  --mechanic-input-font: \"Object Sans\", Helvetica, sans-serif;\n  --mechanic-error: #f04b17;\n  --mechanic-input-height: 2.5em;\n  --mechanic-input-height-half: 1.25em;\n  --mechanic-input-height-quart: 0.75em;\n  --mechanic-input-height-eighth: 0.375em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
